export default __webpack_public_path__ + "static/media/hilbi-logo-rounded.6f689e11.svg";